import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import Moment from "moment";
import {
  Grid,
  DialogActions,
  DialogContent,
  Dialog,
  Box,
  FormLabel,
  Alert,
} from "@mui/material";

import {
  cardBodyStyle,
  ButtonStyle0,
  ButtonExit,
  blackColor,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function TransactionPaymentClientsAdmin(props) {
  const classes = useStyles();

  const [openAlertSuccess, setopenAlertSuccess] = useState(false);
  const [mensaje_success, setmensaje_success] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [disabled, setDisabled] = useState(false);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setError(false);
    setopenAlertSuccess(false);

    const dataValue = {
      adminPayment: 1,
      adminPaymentDate: Moment(),
    };

    axios
      .put(`${urlServices}payment-link/${props.id.id}`, dataValue, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        setopenAlertSuccess(true);
        setmensaje_success(response.data.message);
        props.callBackRefresh();
        setDisabled(true);
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ...",
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
      });
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
                <div className={classes.titleCardFilter}>
                  Cambiar estado a pagado
                </div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Referencia:{" "}
                </FormLabel>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  {`${props.id.reference}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: "-5px" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Cliente:{" "}
                </FormLabel>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  {`${props.id.client.companyName}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: "-5px" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Email:{" "}
                </FormLabel>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  {`${props.id.client.email}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: "-5px" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Documento:{" "}
                </FormLabel>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  {`${props.id.client.documentId}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "center" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: "#000", fontWeight: "bold" }}
                >
                  Información Bancaria
                </FormLabel>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: "-5px" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Banco:{" "}
                </FormLabel>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  {`${props.id.client.nameBank}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: "-5px" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Nº de cuenta:{" "}
                </FormLabel>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  {`${props.id.client.numberAccountBank}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "center" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: "#000", fontWeight: "bold" }}
                >
                  Información del pago
                </FormLabel>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  SubTotal:{" "}
                </FormLabel>
                <br></br>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  $
                  {`${props.id.description === "PAGO POR API" ? props.id.total : props.id.subTotal}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Iva {`${props.id.iva}`}%:{" "}
                </FormLabel>
                <br></br>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  ${`${props.id.ivaSubtotal}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Total:{" "}
                </FormLabel>
                <br></br>
                <span style={{ fontWeight: 500, marginLeft: 10 }}>
                  ${`${props.id.total}`}
                </span>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "center" }}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: "#000", fontWeight: "bold" }}
                >
                  Monto total al cliente
                </FormLabel>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor, fontWeight: "bold" }}
                >
                  Menos (-) comisión:{" "}
                </FormLabel>
                <br></br>
                <div
                  style={{
                    fontWeight: 600,
                    textAlign: "center",
                    color: "green"
                  }}
                >
                  -${`${props.id.commissionPayment}`}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                sx={{
                  textAlign: "center",
                  background: "rgb(237, 247, 237)",
                  color: "rgb(30, 70, 32)",
                }}
              >
                <Box sx={{ fontWeight: "bold" }}>Total a transferir: </Box>
                <Box
                  sx={{
                    fontWeight: "bold",
                    padding: "10px 6px",
                    textAlign: "center",
                    fontSize: 16,
                  }}
                >
                  ${`${props.id.commissionPaymentTotal}`}
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                sx={{ mt: 4, display: disabled ? "none" : "block" }}
              >
                <center>
                  <ButtonStyle0 type="submit" onClick={submitForm}>
                    Pagado
                  </ButtonStyle0>
                </center>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 3 }}>
                <center>
                  {openAlertSuccess && (
                    <Alert severity="success">{mensaje_success}</Alert>
                  )}
                </center>
              </Grid>
            </Grid>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
